import './targetingSection.scss';

type Props = {
  label: string;
  description: string;
};

export function TargetingSection({ label, description }: Props) {
  return (
    <div className="targetingSection">
      <label className="targetingSection__label">{label}</label>
      <div className="targetingSection__bar">
        <div className="targetingSection__barContent" />
      </div>
      <p className="targetingSection__description">{description}</p>
    </div>
  );
}
